var _path, _polygon, _text, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _polygon3, _polygon4, _polygon5, _path8, _rect2, _rect3, _rect4, _path9, _path10, _path11, _polygon6, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect5, _rect6, _path22, _polygon7, _path23, _path24, _path25, _path26, _circle, _path27, _rect7, _path28, _circle2, _path29, _path30, _path31, _path32, _path33, _circle3, _path34, _line, _line2, _text2, _text3, _text4, _text5, _text6, _text7, _g, _g2, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMethodology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306.51,294.28l37.23,8.72,19.77-22.1s26.42,89.37,127.14,98.91l-129.33,1.19s-30.95-25.06-54.81-86.72Z",
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "263.01 377.81 280.68 405.98 264.12 436.35 488.86 436.35 507.08 404.87 490.75 377.72 263.01 377.81",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(363.51 410.66)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 12,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REQUIREMEN"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.45,
    y: 0,
    letterSpacing: "0em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.34,
    y: 0
  }, "S"))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "500.45 436.15 788.24 435.71 806.22 407.05 789.36 377.84 591.59 377.84 500.45 436.15",
    fill: "#a1a1a1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M585.26,113.12l2.23-29,34.42-16.09s-54.53-43.41-131.86-38.49c0,0-52.74,.44-97,30.39l3.13,36.65,29.06,11.15s77.77-52.72,160.02,5.39Z",
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M631.74,75.57c111.3,104.59,62.35,220.28,62.35,220.28l-23.52-26.23-30.51,6.43c27.27-102.24-44.49-155.23-44.49-155.23l2.67-30,33.5-15.25Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M666.64,280l-30.51,7.22s-30.56,88.76-131.27,92.33l14.45,24.49-18.86,32.11s131.74,7.72,190.74-128.15l-24.55-28Z",
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.42,282.95s-38.09-129.29,78.15-215.98l3.76,37.66,26.59,11.17s-75.73,54.53-53.35,151.08l-20.12,23.68-35.03-7.61Z",
    fill: "#a1a1a1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.96,317.83h-40.54c-2.51,0-4.55,2.04-4.55,4.55v67.37h45.09s0-71.92,0-71.92h0Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.32,317.83h-40.53c-2.51,0-4.55,2.04-4.55,4.55v67.37h45.08s0-71.92,0-71.92h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127.19,
    y: 415.51,
    width: 5.37,
    height: 37.57,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.53 488.07 181.53 600.33 173.89 600.33 169.49 482.47 181.53 488.07",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "134.71 465.97 134.71 582.97 127.06 582.97 122.9 460.6 134.71 465.97",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.19 479.99 113.24 450.94 142.56 445.85 176.41 431.33 178.19 479.99",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.28,492.14l-77-35.83v-5.37s64.91,29.05,64.91,29.05c0,0,7.55,8.26,12.09,12.15Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 363.35,
    y: 413.9,
    width: 11.81,
    height: 172.29,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.72,
    y: 413.37,
    width: 11.81,
    height: 208.25,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75.66,
    y: 399.95,
    width: 11.81,
    height: 186.25,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M424,409.88l-54.85-27.62H59.7c-.05,0-.07,.07-.03,.1l36.39,27.79H423.94c.15,0,.2-.2,.06-.27Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M304.31,605.52l30.87,24.15c1.91,1.49,3.64,3.2,5.06,5.16,3.05,4.2,5.98,10.95-1.58,15.78,0,0-14.43,9.02-27.58-3.53-1.92-1.83-3.53-3.96-4.91-6.22l-18-29.41,16.15-5.93Z",
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M296.26,589.95l8,15.57s3.32,4-1.25,6.48c-1.25,.67-2.64,1.01-4.06,1h-7.9c-1.17,0-2.26-.56-2.94-1.51l-9.69-13.67s13.59-5.23,17.84-7.87Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "298.1 556.12 294.58 566.75 289.24 551.55 298.1 556.12",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M135.65,378.29c0,8.24,5.5,8.24,5.5,8.24l15,5.37c6.68,2.23,9.44,1.89,10.5,1.46,.45-.17,.94-.13,1.36,.1,.02,.03,.05,.05,.08,.06,1.16,.81,2.45,1.4,3.82,1.75h0c2.89,.58,2.48-2.31,2.48-2.31-.1-.51-.16-1.02-.2-1.54-.14-4.01,2.15-7.71,5.8-9.37,1.53-.71,3.13-1.27,4.77-1.68,1.01-.25,2.06-.25,3.07,0l8.33,1.91h41.87s38.39-1.12,38.39-1.12c3.57-22.63-.88-45.79-12.58-65.48-2.57-4.41-5.52-8.58-8.82-12.47-.72-.84-1.14-1.27-1.14-1.27l-2.37-3.43s-32,2.14-32.37,1.07-22.15-14-22.15-14l-30.76,13c-1.37,.6-2.59,1.48-3.59,2.59-6.62,6.85-11.81,23.17-11.81,23.17l-14,46.16c-.72,2.54-1.12,5.15-1.18,7.79Z",
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.62,350.89s30.74,5,53.75,.22c.59-.12,1.17-.27,1.75-.43,9.04-2.38,18.4-3.32,27.74-2.79l22.06-.18,1.09,7.3h-36.87s-12,.39-21.7,3.61c0,0-9.66,3.22-29,1.07l-21.82-2.66,3-6.14Z",
    fill: "#a1a1a1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.08,417.66c0,.17,0,8.76,2.14,25.76l.34,2.43c.32,2.41,.5,4.84,.52,7.27,.06,3.84,2.56,11.15,21.3,8.21-.49-.83-.94-1.65-1.36-2.49l-.35-.68c-1.57-3-3.69-7.58-4.35-11.52,0,0,59-5.36,78.37-12.88,0,0,28.3-11.81,38.84-8.05l8.39,7s7.51-2.15-3.22-15l-140.62-.05Z",
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.32,446.64s-13.8,.92-13.29,7c.11,1.14,.69,2.17,1.61,2.85,1.84,1.41,6.25,3.29,16.15,1.89-1.88-3.75-3.37-7.69-4.47-11.74Z",
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.32,446.64c1,3.99,2.46,7.86,4.35,11.52l.35,.68c.23,.43,.44,.81,.63,1.15s.47,.89,.73,1.34c13.3,23.42,41.56,44.44,53.06,52.37,3.07,2.11,5.01,5.5,5.27,9.22,2.38,36.84,19.34,68.64,19.34,68.64,3.61,5.17,9,7.66,15,8.46,19.1,2.58,45.12-11.68,45.12-11.68l-14-39.72c-11.81-44-23.61-56.89-23.61-56.89l-26.54-55.12-1.37-2.85c-19.29,7.52-78.33,12.88-78.33,12.88Z",
    fill: "#a1a1a1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M257.05,476.06l31.35,12.72c1.06,.43,1.53,1.67,1.01,2.69l-12.05,24.11s5.54,16.19,11.4,35.76c0,0,13.42,9.12,27.37,8.05,0,0,11.81-30.06,18.25-61.19,0,0,4.72-21.09-6.44-30.06l-43.52-35.2-8.93-7.23s-6.64-4.83-38.84,8.05l20.4,42.3Z",
    fill: "#a1a1a1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M298.8,578.77l21.27,16.42c2.07,1.63,4.36,2.95,6.81,3.93,3.21,1.25,7.85,4,6.84,9.17-.57,2.75-2.47,5.03-5.07,6.09-2.55,1.06-6.59,1.78-12.53,.37l-11.81-9.23-7.47-14.54,5.33-2.64-3.37-9.57Z",
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M424.34,410.15H96.06s0,7.51,0,7.51H424.34c.11,0,.2-.09,.2-.2v-7.11c0-.11-.09-.2-.2-.2Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.06,410.15v7.49s-.01,.01-.02,0l-36.48-28.97-.02-5.98c0-.18,.2-.28,.35-.17l36.17,27.62Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M338.66,390.82h-98.07s7.33-63.74,7.33-63.74c.31-2.84,2.71-5,5.57-5h90c1.66,.03,2.98,1.4,2.95,3.05,0,.09,0,.17-.02,.26l-7.76,65.43Z",
    fill: "#a1a1a1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 244.2,
    y: 390.82,
    width: 94.46,
    height: 6.44,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 214.71,
    y: 390.82,
    width: 29.49,
    height: 6.44,
    fill: "#a1a1a1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M426.25,399.41h-46.22s.05,4.82,.05,4.82c0,.34,.28,.61,.62,.6l45.55-.77c.24,0,.43-.2,.43-.43v-3.79c0-.24-.19-.43-.43-.43Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "346.45 379.83 346.45 385.69 380.04 404.06 380.04 399.41 346.45 379.83",
    fill: "#ccc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M346.45,380.21v5.19c0,.17,.09,.33,.24,.41l32.48,18.74c.38,.22,.86-.06,.86-.5v-4.65s-33.26-19.39-33.26-19.39c-.15-.09-.33,.02-.33,.19Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M187.86,380.35s11.64,1.62,19.28,10.04c1.03,1.14,2.02,2.32,3.08,3.44,2.36,2.5,6.17,7.34-1.24,6.13,0,0-.47,4.68-8.39,1.53,0,0-1.37,3.31-10-1.53,0,0-8.64-4.84-16.16-7-.02,.01-3.19-12.36,13.42-12.61Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M205.55,274.78s-12.2-4.93-24.24-3.72c-6.73,.73-12.93,4.01-17.33,9.17-4.85,5.6-11.54,15.1-4.38,18.3,2.36,.98,5.03,.86,7.29-.33,5-2.49,17.91-6.91,47.79,12.65l-27.37-23.08s-6.49-6.48,3.5-8.53c.86-.17,1.74-.25,2.62-.25,3.37,.06,6.72,.48,10,1.27,0,0,2.12-3.44,2.12-5.48Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M220.58,311.39c4.44-2.67,21.36-6.8,27.08-8.15,1.11-.25,2.24-.41,3.37-.5,4.81-.45,3.9-3.16,3.9-3.16,0-4.29-6.63-7.09-6.63-7.09-6,6.11-13.48,8.26-20.74,7l-6.98,11.9Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 295.19,
    cy: 357.01,
    r: 8.05,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M187.31,287.77l26.83,22.77c4.3,3.45,6.44,.85,6.44,.85l1.19-1.87,6.79-10c-20.4-4.65-19.67-30.41-19.67-30.41h-3.34c.55,3.87-.21,7.81-2.14,11.2-3.91-1.57-9-1.42-11.4-1.23-.98,.07-1.95,.23-2.89,.49-8.63,2.32-1.81,8.2-1.81,8.2Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 208.16,
    y: 231.56,
    width: 51.48,
    height: 68.95,
    rx: 25.74,
    ry: 25.74,
    transform: "translate(373.92 591.44) rotate(-161.96)",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M254.86,209.96c-3.71-2.41-8.82-4.56-13.41-2.43-6.4,2.98-13.38,4.24-20.4,3.56-1.43-.14-2.97-.05-4.6,.34h0c-.77,.18-1.52,.42-2.25,.72,0,0-2.16,.57-3.99,2.97-3.2,4.17-7.7,7.19-12.89,7.94-2.5,.36-5.2,1.64-7.81,4.57,0,0-6.44,7.89,0,16.28-.08,.02-3.27,7.35,5.32,12.72,0,0-17.18,9.45,10.73,18.14,.33-1.19,.51-2.42,.54-3.65,.04-1.53-.14-3.06-.54-4.54l8.59-4.36s4.67,.85,7.17-4.52c0,0,8.93,0,7.86-6.44,0,0,6.44,4.3,8.59-1.07,0,0,9.69,6.88,19.33-4.62,0,0,6.51,8.03,2.51,24.03,0,0,6.83,2.05,10.42-2.65,0,0,15.24-21.86-7.51-49.94-2.2-2.71-4.72-5.16-7.65-7.06Z",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.6,
    cy: 369.61,
    r: 3.5,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M425.89,399.41h-45.85s-33-19.23-33-19.23c-.16-.1-.1-.35,.09-.35h39.43s39.4,19.23,39.4,19.23c.18,.09,.12,.35-.08,.35Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M168.01,393.46s-.91-8.61,3.09-13.61",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M188.1,379.84l-21.3-18.4c-.71-.65-.88-1.69-.44-2.54l8.24-15.56",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M167.6,304.34s20,5,14,24",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M199.88,302.56s5.72,28.32-1.28,64.05",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.6,
    cy: 369.61,
    r: 3.5,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M234.6,306.34s6,25.54-1,59.77",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200.6,
    y1: 401.49,
    x2: 191.6,
    y2: 394.34,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 208.99,
    y1: 399.96,
    x2: 199.1,
    y2: 390.84,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(710.04 411.15)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 12,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lau"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.61,
    y: 0,
    letterSpacing: "0em"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.09,
    y: 0,
    letterSpacing: "0em"
  }, "ch"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(604.04 360.08)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 12,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DESIGN"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(493.51 67.08)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 12,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TE"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.05,
    y: 0,
    letterSpacing: "-.01em"
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.99,
    y: 0,
    letterSpacing: "0em"
  }, "T"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(314.51 184.08)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 12,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEP"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.66,
    y: 0,
    letterSpacing: "0em"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.44,
    y: 0,
    letterSpacing: "-.02em"
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.63,
    y: 0
  }, "Y"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(352.51 357.08)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 12,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.36,
    y: 0,
    letterSpacing: "0em"
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.57,
    y: 0
  }, "VI"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.03,
    y: 0,
    letterSpacing: "0em"
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.24,
    y: 0
  }, "W"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(642.04 180.08)",
    fill: "#002346",
    fontFamily: "Barlow-SemiBold, Barlow",
    fontSize: 12,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.42,
    y: 0,
    letterSpacing: "0em"
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.63,
    y: 0,
    letterSpacing: "0em"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.84,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.94,
    y: 0,
    letterSpacing: "0em"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.72,
    y: 0
  }, "OP"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 493.14,
    y: 177.51,
    width: 10.85,
    height: 12.06,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.31,
    y: 187.76,
    width: 7.72,
    height: 13.26,
    transform: "translate(-19.86 332.92) rotate(-39.15)",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.86,
    y: 181.65,
    width: 8.8,
    height: 12.77,
    rx: 1.37,
    ry: 1.37,
    transform: "translate(328 -286.42) rotate(52.68)",
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.84,
    y: 188.02,
    width: 7.72,
    height: 13.26,
    transform: "translate(214.9 -277.84) rotate(35.71)",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.16,
    y: 181.87,
    width: 8.8,
    height: 12.77,
    rx: 1.37,
    ry: 1.37,
    transform: "translate(1024.03 -128.03) rotate(127.54)",
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.87,
    cy: 247.15,
    r: 61.2,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.87,
    cy: 247.15,
    r: 53.36,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.76,
    y: 201.02,
    width: 4.22,
    height: 9.65,
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.76,
    y: 284.23,
    width: 4.22,
    height: 9.65,
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.66,
    y: 278.8,
    width: 4.22,
    height: 9.65,
    transform: "translate(184.29 -188.16) rotate(27.42)",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.59,
    y: 263.73,
    width: 4.22,
    height: 9.65,
    transform: "translate(492.73 -265.59) rotate(63.09)",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.59,
    y: 222.12,
    width: 4.22,
    height: 9.65,
    transform: "translate(890.59 -60.28) rotate(120)",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.66,
    y: 206.45,
    width: 4.22,
    height: 9.65,
    transform: "translate(994.89 137.21) rotate(147.99)",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.26,
    y: 206.45,
    width: 4.22,
    height: 9.65,
    transform: "translate(157.14 -216.71) rotate(27.62)",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.34,
    y: 222.12,
    width: 4.22,
    height: 9.65,
    transform: "translate(463.77 -349.37) rotate(60)",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.36,
    y: 242.62,
    width: 4.22,
    height: 9.65,
    transform: "translate(787.92 -293.03) rotate(90)",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.64,
    y: 263.43,
    width: 4.22,
    height: 9.65,
    transform: "translate(1034.43 -60.73) rotate(120)",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.56,
    y: 278.5,
    width: 4.22,
    height: 9.65,
    transform: "translate(1109.22 230.68) rotate(146.3)",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.86,
    y: 242.62,
    width: 4.22,
    height: 9.65,
    transform: "translate(704.42 -209.52) rotate(90)",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.97,215.93l-30.04,23.8c-.44-.08-.9-.13-1.36-.13-4.43,0-8,3.68-7.83,8.14,.15,4.03,3.49,7.37,7.53,7.53,4.47,.17,8.14-3.4,8.14-7.83,0-.39-.04-.77-.09-1.14l23.77-30.26c.06-.08-.04-.18-.12-.12Z",
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.57,
    cy: 247.45,
    r: 4.22,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.27,137.11c-11.49,0-20.8,9.31-20.8,20.8s9.31,20.8,20.8,20.8,20.8-9.31,20.8-20.8-9.31-20.8-20.8-20.8Zm0,37.98c-9.49,0-17.18-7.69-17.18-17.18s7.69-17.18,17.18-17.18,17.18,7.69,17.18,17.18-7.69,17.18-17.18,17.18Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.32,
    y: 166.05,
    width: 20.5,
    height: 15.07,
    rx: 2.69,
    ry: 2.69,
    fill: "#ffa200",
    stroke: "#002346",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M541.17,393.3c1.77-8.72,8.71-15.39,17.31-17.67,12.17-3.22,32.17-2.76,48.51,25.23,0,0,15.26,24.74,6.32,60.61,0,0-1.83-18.21-30.59-31.25-3.17-1.44-6.46-2.62-9.79-3.65-8.99-2.78-35.9-12.9-31.76-33.27Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.25,362.83c-3.89,.74-7.46,2.78-9.83,5.95-4.62,6.18-8.12,19.13,3.77,45.11,0,0,17.55,37.04-11.14,81.25,0,0,46.28-20.65,57.96-64.34,4.04-15.12,2.88-31.26-3.63-45.5-5.89-12.88-16.97-26.32-37.13-22.47Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.36,554.34s-22.44-33.12,16.29-66.62c.87-.75,1.77-1.47,2.67-2.18,7.3-5.79,51.38-43.88,21.04-97.2",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.94,401.39s40.99,27.12,23.2,75.04c0,0-19.78,48.92,1.22,76.92",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.98,478.27c.05-5.53,3.5-10.42,8.48-12.8,7.03-3.35,19.26-5.37,32.4,9.82,0,0,11.91,13.11,10.75,35.62,0,.11-.16,.14-.2,.04-.87-2.14-5.38-10.98-21.98-15.06-2.09-.51-4.22-.86-6.36-1.11-5.76-.67-23.2-3.75-23.09-16.52Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.36,505.34s28.01-22.33,57.51-.66c0,0,13.64,10.28,10.04,21.19-1.43,4.35-5.37,7.36-9.89,8.12-5.89,.99-15.9,.69-26.67-8.37,0,0-23.93-18.34-30.98-20.28Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.86,553.84s4-69,70-47",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "642.86 624.84 580.86 624.84 576.86 551.84 646.86 551.84 642.86 624.84",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.86,581.34c4.06-1.95,10.14-4.15,17.5-4,7.18,.15,11.71,2.47,16.51,4,6.9,2.2,17.28,3.7,31.99,0",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.86,590.34c4.06-1.95,10.14-4.15,17.5-4,7.18,.15,11.71,2.47,16.51,4,6.9,2.2,17.28,3.7,31.99,0",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.86,481.84s27,11,34,70",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M315.35,618s-8.99-2.38-13.62,6.73",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M321.35,624s-8.99-2.38-13.62,6.73",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M326.35,629s-8.99-2.38-13.62,6.73",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M291.79,617.18l22.45,25.26c6.33,7.12,17.65,7.14,23.68-.23,.23-.28,.45-.57,.68-.87",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M332.1,634.84s-13.5-2.5-16.5,8.5",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M304.55,606.01s14.04,11.34,25.04,1.34",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1,601.84s-8,0-9.24,8.31",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M318.1,598.84s-8,0-9.24,8.31",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M314.1,594.84s-8,0-9.24,8.31",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethodology);
export default __webpack_public_path__ + "static/media/Methodology.1f935329f3e0d0a3e054db3eadb5d2ef.svg";
export { ForwardRef as ReactComponent };